import { render, staticRenderFns } from "./SettlementRequestDetails.vue?vue&type=template&id=9fb11c88"
import script from "./SettlementRequestDetails.vue?vue&type=script&lang=js"
export * from "./SettlementRequestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports